import "./Main.scss";
import Drawer from "@mui/material/Drawer";
import { ReactNode, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";
import { useBreakpoint } from "../../hooks";
import { LeftSidePanel } from "./leftSideBar/LeftSidePanel";
import { RightSide } from "./rightSideBar/RightSide";
import { SidebarPanel } from "./SidebarPanel";
import { TopAppBar } from "./TopAppBar";
import { MobileNavigationProvider } from "../../contexts/MobileNavigationContext";

export const Main = () => {
  const { isDesktop } = useBreakpoint();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [topAppBarActions, setTopAppBarActions] = useState<ReactNode>(null);
  const [topAppBarTitle, setTopAppBarTitle] = useState<string | null>(null);
  const location = useLocation();
  const mobileNavigationValue = useMemo(
    () => ({
      openNavigation: () => setDrawerOpen(true),
      title: topAppBarTitle,
      setActions: setTopAppBarActions,
      setTitle: setTopAppBarTitle,
    }),
    [topAppBarTitle],
  );

  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  return (
    <section
      className={`container-fluid main-container pe-0 ${
        isDesktop ? "" : "main-container--mobile"
      }`}
    >
      <MobileNavigationProvider value={mobileNavigationValue}>
        {!isDesktop && (
          <>
            <TopAppBar
              onMenuClick={() => setDrawerOpen(true)}
              actions={topAppBarActions}
            />

            <Drawer
              anchor="left"
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
              className="mobile-nav-drawer"
            >
              <SidebarPanel
                className="mobile-nav-drawer__panel"
                isExpanded={true}
                setIsExpanded={() => setDrawerOpen(false)}
                onNavigate={() => setDrawerOpen(false)}
              />
            </Drawer>
          </>
        )}

        <div className="d-flex main-layout-row">
          {isDesktop && <LeftSidePanel />}
          <RightSide />
        </div>
      </MobileNavigationProvider>
    </section>
  );
};
